<template>
    <div>
        <a-spin :spinning="loading">
            <!--    搜索条件    -->
            <div class="mb20">
                <a-form layout="inline" class="mb10">
                    <a-form-item :label="$t('web.name' /* 姓名 */)">
                        <a-input v-model="searchParams.name" style="width: 150px" />
                    </a-form-item>
                    <a-form-item :label="$t('web.company' /* 单位 */)">
                        <a-input v-model="searchParams.org" style="width: 150px" />
                    </a-form-item>
                    <a-form-item :label="$t('program.title' /* 标题 */)">
                        <a-input v-model="searchParams.title" style="width: 150px" />
                    </a-form-item>
                    <a-form-item :label="$t('program.speech_type' /* 发言类型 */)">
                        <a-select v-model="searchParams.type" allowClear style="width: 150px">
                            <a-select-option v-for="item in fayanList" :value="item.id" :key="item.id">
                                {{ item['typename_' + $route.params.lang] }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" class="mr5" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                    </a-form-item>
                </a-form>
                <a-button type="primary" @click="handleBackEvent">{{ $t('program.back_to_schedule_list' /* 返回日程一览 */) }}</a-button>
            </div>
            <!--  表格  -->
            <a-table
                ref="table"
                :rowKey="record => record.id"
                :columns="columns"
                :data-source="dataSource"
                :pagination="pagination"
                :scroll="{ x: 1520 }"
                @change="handleTableChange"
                @showSizeChange="handleTableChange"
            >
                <template slot="starttime_slot" slot-scope="text, record">
                    <div>{{ text }}-{{ record.endtime_slot }}</div>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button @click="handleEdit(record)" type="link">{{ $t('web.edit' /* 编辑 */) }}</a-button>
                    <!-- <a-divider type="vertical" /> -->
                    <a-button @click="handleDelete(record)" type="link">{{ $t('web.delete' /* 删除 */) }}</a-button>
                    <a-button @click="$refs.childSessionDrawerRef.show(record)" type="link">{{ $t('program.view_session' /* 查看该Session */) }}</a-button>
                </template>
            </a-table>
        </a-spin>
        <!-- 编辑 -->
        <schedule-update-drawer ref="scheduleUpdateDrawer"></schedule-update-drawer>
        <!-- 查看日程 -->
        <child-session-drawer ref="childSessionDrawerRef"></child-session-drawer>
    </div>
</template>
<script>
import scheduleUpdateDrawer from './components/schedule-update-drawer.vue';
import childSessionDrawer from './components/child-session-drawer.vue';

export default {
    name: 'SearchDutyList',
    components: { scheduleUpdateDrawer, childSessionDrawer },
    data() {
        return {
            searchParams: {
                name: '',
                org: '',
                title: '',
                type: ''
            },
            fayanList: [], // 发言类型列表
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => {
                    this.$t('web.pagination_total', { value: total } /* 共 {total} 条 */);
                },
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '30', '50', '100']
            },
            dataSource: [],
            columns: [
                {
                    title: this.$t('web.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    align: 'left',
                    fixed: 'left',
                    width: 120
                },
                {
                    title: this.$t('web.time' /* 时间 */),
                    dataIndex: 'starttime_slot',
                    scopedSlots: { customRender: 'starttime_slot' },
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('program.batch_live_label_hall' /* 会场 */),
                    dataIndex: 'meeting_hall',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.batch_live_label_xuezu' /* 专题分论坛 */),
                    dataIndex: 'class_cnname',
                    align: 'left',
                    width: 150
                },
                {
                    title: 'Session',
                    dataIndex: 'session_name',
                    align: 'left',
                    width: 100
                },
                {
                    title: this.$t('program.task' /* 任务 */),
                    dataIndex: 'typename_cn',
                    align: 'left',
                    width: 100
                },
                {
                    title: this.$t('program.role' /* 角色 */),
                    dataIndex: 'type',
                    align: 'left',
                    width: 100
                },
                {
                    title: this.$t('program.theme' /* 主题 */),
                    dataIndex: 'abstract_title',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('web.name' /* 姓名 */),
                    dataIndex: 'real_name',
                    align: 'left',
                    width: 100
                },
                {
                    title: this.$t('web.company' /* 单位 */),
                    dataIndex: 'org_cnname',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    width: 280
                }
            ],
            loading: false
        };
    },
    methods: {
        /**
         * ## 获取发言类型下拉列表
         */
        getFayanListFun() {
            this.$request.get({ url: 'getProgramFayanList' }).then(res => {
                this.fayanList = res.data;
            });
        },
        /**
         * ## 获取日程任务列表
         */
        getDataList() {
            let data = {
                ...this.searchParams,
                page: this.pagination.current,
                limit: this.pagination.pageSize
            };
            this.loading = true;
            this.$request
                .get({ url: 'getSearchDutyList', data })
                .then(res => {
                    this.dataSource = res.data.list;
                    this.pagination.total = Number(res.data.count);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 表格变化
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getDataList();
        },
        // 搜索
        handleSearchEvent() {
            this.pagination.current = 1;
            this.getDataList();
        },
        // 返回日程
        handleBackEvent() {
            this.$router.push(`/program/index/${this.$route.params.lang}/${this.$route.params.meeting_id}`);
        },
        /**
         * ## 编辑
         */
        handleEdit(data) {
            this.$refs.scheduleUpdateDrawer.show(data);
        },
        /**
         * ## 删除
         */
        handleDelete() {}
    },
    created() {
        this.searchParams = this.$route.query;
    },
    mounted() {
        this.getFayanListFun();
        this.getDataList();
    }
};
</script>